import { CampaignProduct } from "../dto/campaign-product.model";

	/**
	 * @description
	 *  Modelo de un producto en una nota de CyR o NC, sobre un pedido, para
	 *	creación.
	 *
	 * @see gigot-backend/ViewModels/OrderEvent/OrderEventProductsForCreationDto.cs
	 */

export class OrderEventProductsForCreation {

	public campaignProductReturnId: number;
	public orderEventId: number;
	public quantity: number;

	/**
	 * @description
	 *	Construye un producto de una nota con una semántica vacía. Nótese que
	 *	no es lo mismo que construir un producto con valores por defecto. Las
	 *	reglas generales de construcción son:
	 *
	 *      - Campos 'array' se definen como [].
	 *      - Campos 'boolean' se definen como 'false'.
	 *      - Campos 'Date' se definen como 'undefined'.
	 *      - Campos 'enum' se definen como 'undefined'.
	 *      - Campos 'number' se definen como 'undefined'.
	 *      - Campos 'string' se definen como '' (cadena vacía).
	 *      - Campos 'object' se definen llamando a su propio método #empty().
	 *      - Campos de la superclase se definen al igual que campos 'object'.
	 *      - Campos genéricos se definen como 'undefined'.
	 *		- Campos recursivos se definen como 'undefined'.
	 *
	 * @returns
	 *	Un producto en una nota de CyR/NC vacío.
	 */
	public static empty(): OrderEventProductsForCreation {
		const orderEventProductsForCreation: OrderEventProductsForCreation = new OrderEventProductsForCreation();
		orderEventProductsForCreation.campaignProductReturnId = undefined;
		orderEventProductsForCreation.orderEventId = undefined;
		orderEventProductsForCreation.quantity = undefined;
		return orderEventProductsForCreation;
	}

	/**
	 * @description
	 *  Método de reificación de un modelo compatible anémico. Esto permite
	 *  ejecutar lógica de negocios sobre el modelo generado, siendo que el
	 *  valor de sus propiedades se mantiene.
	 *
	 * @param anemicOrderEventProductsForCreation
	 *  El modelo anémico a reificar.
	 *
	 * @returns
	 *  Devuelve un modelo de esta clase, cuyas propiedades fueron copiadas en
	 *  profundidad desde el modelo anémico.
	 */
	public static from(anemicOrderEventProductsForCreation: OrderEventProductsForCreation): OrderEventProductsForCreation {
		if (!anemicOrderEventProductsForCreation) return undefined;
		const orderEventProductsForCreation: OrderEventProductsForCreation = OrderEventProductsForCreation.empty();
		orderEventProductsForCreation.campaignProductReturnId = anemicOrderEventProductsForCreation.campaignProductReturnId;
		orderEventProductsForCreation.orderEventId = anemicOrderEventProductsForCreation.orderEventId;
		orderEventProductsForCreation.quantity = anemicOrderEventProductsForCreation.quantity;
		return orderEventProductsForCreation;
	}

	/**
	 * @description
	 *	.
	 *
	 * @param campaignProduct
	 *	.
	 * @param quantity
	 *	.
	 *
	 * @returns
	 *	.
	 */
	public static fromCampaignProduct(campaignProduct: CampaignProduct, quantity: number): OrderEventProductsForCreation {
		if (!campaignProduct) return undefined;
		const orderEventProductsForCreation: OrderEventProductsForCreation = OrderEventProductsForCreation.empty();
		orderEventProductsForCreation.campaignProductReturnId = campaignProduct.id;
		orderEventProductsForCreation.orderEventId = undefined;
		orderEventProductsForCreation.quantity = quantity;
		return orderEventProductsForCreation;
	}
}
